/**
 * $.uiDrawerBottom() plugin.
 *
 * It is allowed to call several $.uiDrawerBottom() at the same time.
 * Also compatible with using multiple .uiModal() at the same time.
 *
 * Options:
 *     esc:                       boolean (default: true)  - Closes the $.uiDrawerBottom() when press [Escape].
 *     lock_body_scroll:          boolean (default: true)  - When opened, the scroll of the page is blocked.
 *     fullscreen:                boolean (default: false) - Renders the $.uiDrawerBottom() in full screen. (TODO: in theory it should be made only for mobile devices)
 *     header_contrast:           boolean (default: false) - Makes the header contrast (dark background, white text).
 *     header_underline:          boolean (default: false) - Makes the header underline (bottom border).
 *     close_on_avia_before_load: boolean (default: true)  - Close the drawer before starting content loading.
 *
 *     html:     string        - Custom html for $.uiDrawerBottom(). Must contain all UIDrawerBottom.class to work correctly.
 *                               Required if there is no $wrapper, header, content and footer.
 *     $wrapper: jQuery object - Custom jQuery object for $.uiDrawerBottom(). Must contain all UIDrawerBottom.class to work correctly.
 *                               Required if there is no html, header, content and footer.
 *
 *     header:  string - The string to be added to the header.
 *     content: string - The string to be added to the content.
 *     footer:  string - The string to be added to the footer.
 *
 *         Attention! 'header', 'content' and 'footer' fields are required unless the 'html' or '$wrapper' options are passed.
 *
 *     custom_focus_class: string(optional) - Set focus on custom element supportive focus after open modal. Default set on the $modal_body with tabindex=-1.
 *
 *     onBgClick: function - Callback, that will be called when the background is clicked.
 *     onOpen:    function - Callback, which will be called when the $.uiDrawerBottom() is opened.
 *     onClose:   function - Callback, which will be called when the $.uiDrawerBottom() is closes.
 *     onResize:  function - Callback, that will be called when the $.uiDrawerBottom() is resized.
 */
(function ($) {

    var UIDrawerBottom = (function ($) {

        UIDrawerBottom = function (options) {
            var that = this;

            that.class = {
                body_locker: 'js-body-locker', // Required to synchronize with other locker-elements on the page (other-modals, drawers, etc..)
                wrapper: 'drawer-bottom',
                wrapper_fullscreen: 'drawer-bottom-fullscreen',
                background: 'drawer-bottom-background',
                body: 'drawer-bottom-body',
                header: 'drawer-bottom-header',
                header_contrast: 'drawer-bottom-header-contrast',
                header_underline: 'drawer-bottom-header-underline',
                close_icon: 'drawer-bottom-close-icon',
                content: 'drawer-bottom-content',
                footer: 'drawer-bottom-footer',
            };

            that.icons = {
                close: '<i class="fab fa-sa-x"></i>',
            };

            that.fullscreen = (options['fullscreen'] || false);
            that.header_contrast = (options['header_contrast'] || false);
            that.header_underline = (options['header_underline'] || false);
            that.close_on_avia_before_load = (options['close_on_avia_before_load'] || true);
            that.custom_focus_class = (options['custom_focus_class'] || null);

            that.$wrapper = options['$wrapper'] || that.getWrapper(options);

            if (that.$wrapper && that.$wrapper.length) {
                // DOM
                that.$block = that.$wrapper.find(that.getSelector('body'));
                that.$background = that.$wrapper.find(that.getSelector('background'));
                that.$body = $(document).find('body');

                // CONST
                that.esc = (typeof options['esc'] === 'boolean' ? options['esc'] : true);

                // VARS
                that.lock_body_scroll = (typeof options['lock_body_scroll'] === 'boolean' ? options['lock_body_scroll'] : true);
                that.options = (options['options'] || false);

                // DYNAMIC VARS
                that.is_visible = false;
                that.is_removed = false;

                // HANDLERS
                that.onBgClick = (options['onBgClick'] || false);
                that.onOpen = (options['onOpen'] || function () {
                });
                that.onClose = (options['onClose'] || function () {
                });
                that.onResize = (options['onResize'] || false);

                // INIT
                that.init();

            } else {
                $.sa.log('Error drawer-bottom: bad data');
            }
        };

        UIDrawerBottom.prototype.init = function () {
            var that = this;
            // save link on drawer-bottom
            that.$wrapper.data('drawer_bottom', that);
            //
            that.render();

            // Delay binding close events so that drawer-bottom does not close immidiately
            // from the same click that opened it.
            setTimeout(function () {
                that.bindEvents();
            }, 0);
        };

        UIDrawerBottom.prototype.bindEvents = function () {
            var that = this,
                $document = $(document),
                $block = (that.$block) ? that.$block : that.$wrapper;

            $.sa.$document.on('avia_before_load', function () {
                if (that.close_on_avia_before_load) {
                    that.close();
                }
            });

            $block.on('click', '.js-close-drawer-bottom', function (event) {
                event.preventDefault();
                that.close();
            });

            that.$wrapper.on('close', function () {
                that.close();
            });

            that.$wrapper.on('click', '.js-close', function () {
                that.close();
            });

            // Handler for Android back button
            $.sa.$window.on('popstate', function () {
                // that.close();
            });

            // Click on background, default nothing
            that.$wrapper.on('click', that.getSelector('background'), function (event) {
                if (typeof that.onBgClick === 'function') {
                    if (false !== that.onBgClick(that, event)) {
                        that.close();
                    }
                    return false;
                }
                that.close();
            });

            if (that.esc) {
                $document.on('keydown', escapeWatcher);

                function escapeWatcher(event) {
                    var is_exist = $.contains(document, that.$wrapper[0]);
                    if (is_exist) {
                        var escape_code = 27;
                        if (event.keyCode === escape_code) {
                            that.close();
                        }
                    } else {
                        if (that.is_removed) {
                            $document.off('keydown', escapeWatcher);
                        }
                    }
                }
            }

            $.sa.$window.on('resize', onResize);

            function onResize() {
                var is_exist = $.contains(document, that.$wrapper[0]);
                if (is_exist) {
                    that.resize();
                } else {
                    if (that.is_removed) {
                        $.sa.$window.off('resize', onResize);
                    }
                }
            }

            // refresh drawer-bottom position
            $document.on('refresh', resizeDrawerBottom);

            function resizeDrawerBottom() {
                var is_exist = $.contains(document, that.$wrapper[0]);
                if (is_exist) {
                    that.resize();
                } else {
                    if (that.is_removed) {
                        $document.off('resizeDrawerBottom', resizeDrawerBottom);
                    }
                }
            }
        };

        UIDrawerBottom.prototype.render = function () {
            var that = this;

            try {
                that.show();
            } catch (e) {
                $.sa.log('Error drawer-bottom: ' + e.message);
            }

            if (that.lock_body_scroll) {
                $.sa.scroll_locker.locked();
                that.$wrapper.addClass(that.class.body_locker);
            }

            // trigger event on open
            that.onOpen(that.$wrapper, that);
        };

        UIDrawerBottom.prototype.resize = function () {
            var that = this;

            if (that.onResize) {
                that.onResize(that.$wrapper, that);
            }
        };

        UIDrawerBottom.prototype.show = function () {
            var that = this,
                is_exist = $.contains(document, that.$wrapper[0]);

            if (!is_exist) {
                that.$body.append(that.$wrapper);
            }
            that.$block.addClass('animated').addClass('faster').addClass('fadeInUp');
            that.$wrapper.show();
            that.is_visible = true;

            if (that.lock_body_scroll) {
                $.sa.scroll_locker.locked();
                that.$wrapper.addClass(that.class.body_locker);
            }

            that.custom_focus_class ?
                that.$wrapper.find(that.getSelector(that.custom_focus_class)).focus()
                : that.$block.attr('tabindex', -1).focus();
        };

        UIDrawerBottom.prototype.close = function () {
            var that = this,
                result = null;

            if (that.is_visible && !that.is_removed) {
                //
                result = that.onClose(that);
                //
                if (result !== false) {
                    that.$background.hide();
                    that.$block.removeClass('fadeInUp').addClass('fadeOutDown')
                    setTimeout(function () {
                        const visible_lockers_count = that.$body.find('.' + that.class.body_locker + ':visible').length;

                        that.$wrapper.remove();
                        if (that.lock_body_scroll && visible_lockers_count < 2) {
                            $.sa.scroll_locker.unlocked();
                        }
                        that.is_removed = true;
                    }, 350);

                }
            }

            return result;
        };

        UIDrawerBottom.prototype.hide = function () {
            var that = this;

            that.$block.removeClass('fadeInUp').addClass('fadeOutDown');
            setTimeout(function () {
                $('<div />').append(that.$wrapper.hide());

                that.is_visible = false;
                const visible_lockers_count = that.$body.find('.' + that.class.body_locker + ':visible').length;
                if (that.lock_body_scroll && visible_lockers_count < 2) {
                    $.sa.scroll_locker.unlocked();
                }
            }, 350);

        };

        UIDrawerBottom.prototype.getWrapper = function (options) {
            var that = this,
                result = false;

            if (options['html']) {
                result = $(options['html']);
            } else if (options['wrapper']) {
                result = options['wrapper'];
            } else {
                result = generateUIDrawerBottom(options['header'], options['content'], options['footer']);
            }

            return result;

            function generateUIDrawerBottom($header, $content, $footer) {
                var result = false;

                var $wrapper = $('<div />').addClass(that.class.wrapper).addClass(that.class.body_locker),
                    $bg = $('<div />').addClass(that.class.background),
                    $body = $('<div />').addClass(that.class.body),
                    $header_title = $('<div />').addClass('drawer-bottom-header-title').append($header),
                    $header_close_icon = $('<a />').addClass(that.class.close_icon).addClass('js-close-drawer-bottom').attr('href', 'javascript:void(0);').append(that.icons.close),
                    $header_w = ($header ? $('<div />').addClass(that.class.header).append($header_title).append($header_close_icon) : false),
                    $content_w = ($content ? $('<div />').addClass(that.class.content).append($content) : false),
                    $footer_w = ($footer ? $('<div />').addClass(that.class.footer).append($footer) : false);

                if (options.fullscreen) {
                    $wrapper.addClass(that.class.wrapper_fullscreen);
                }

                if ($header_w || $content_w || $footer_w) {
                    if ($header_w) {
                        if (that.header_contrast) {
                            $header_w.addClass(that.class.header_contrast);
                        }
                        if (that.header_underline) {
                            $header_w.addClass(that.class.header_underline);
                        }
                        $body.append($header_w)
                    }
                    if ($content_w) {
                        $body.append($content_w)
                    }
                    if ($footer_w) {
                        $body.append($footer_w)
                    }
                    result = $wrapper.append($bg).append($body);
                }

                return result;
            }
        }

        UIDrawerBottom.prototype.getSelector = function (name) {
            var that = this;
            return (that.class[name] ? '.' + that.class[name] : null);
        }

        return UIDrawerBottom;

    })($);

    $.uiDrawerBottom = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);
        return new UIDrawerBottom(options);
    };

})(jQuery);
